import React from 'react';
import { Button, Col, Modal, Nav, Tab, Row } from 'react-bootstrap';
import PdfObject from '../../../PdfObject';

interface IProps {
  container: object;
  docs: Array<{
    title: string;
    url: string;
  }>;
  hide: () => void;
  show: boolean;
  signatureCapture: boolean;
  signatureCaptureDocID: string;
}

export default function screenPrintModal(props: IProps) {
  return (
    <Modal
      backdrop="static"
      size="xl"
      container={props.container as any}
      dialogClassName="sk-screenPrintModal"
      onHide={() => props.hide()}
      show={props.show}
    >
      <Modal.Header closeButton={true}>
        <Modal.Title>Print Documents</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Tab.Container id="left-tabs-example" defaultActiveKey="evt0">
          <Row className="clearfix">
            <Col sm={3}>
              <Nav variant="pills" className="flex-column">
                {props.docs.map((doc, index) => (
                  <Nav.Item key={index}>
                    <Nav.Link eventKey={`evt${index}`}>{doc.title}</Nav.Link>
                  </Nav.Item>
                ))}
              </Nav>
            </Col>
            <Col sm={9}>
              <Tab.Content>
                {props.docs.map((doc, index) => (
                  <Tab.Pane key={index} eventKey={`evt${index}`}>
                    <PdfObject url={doc.url} width="100%" height="800" />
                  </Tab.Pane>
                ))}
              </Tab.Content>
            </Col>
          </Row>
        </Tab.Container>
      </Modal.Body>
      <Modal.Footer>
        <div className="sk-screenPrintModalFooter">
          {props.signatureCapture ? (
            <div>
              <Button
                variant="warning"
                onClick={() => window.open(`${window.location.origin}/UCS1/${props.signatureCaptureDocID}`, '_blank')}
              >
                Signature Capture
              </Button>
            </div>
          ) : (
            <div>&nbsp;</div>
          )}
          <div>
            <Button onClick={() => props.hide()} variant="secondary">
              Close
            </Button>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
